// 计算方式
export const CALCULATION_TYPE_ENUM = {
  '1': '按满足率',
  '2': '按欠货天数',
  '3': '按满足率&欠货天数'
}

export const CALCULATION_TYPE_LIST = Object.entries(CALCULATION_TYPE_ENUM).map(([key, value]) => ({
  code: key,
  name: value
}))
